import Rete from 'rete';

export const ACTION_OUTPUT_SOCKET = new Rete.Socket('ACTION_OUTPUT');

export const EFFECT_INPUT_SOCKET = new Rete.Socket('EFFECT_INPUT');
export const EFFECT_OUTPUT_SOCKET = new Rete.Socket('EFFECT_OUTPUT');

export const CHECK_INPUT_SOCKET = new Rete.Socket('CHECK_INPUT');
export const CHECK_OUTPUT_SOCKET = new Rete.Socket('CHECK_INPUT');

export const TIMER_INPUT_SOCKET = new Rete.Socket('TIMER_INPUT');
export const TIMER_OUTPUT_SOCKET = new Rete.Socket('TIMER_OUTPUT');

export const EFFECTCHAIN_INPUT_SOCKET = new Rete.Socket('EFFECTCHAIN_INPUT');
export const EFFECTCHAIN_OUTPUT_SOCKET = new Rete.Socket('EFFECTCHAIN_OUTPUT');

ACTION_OUTPUT_SOCKET.combineWith(EFFECT_INPUT_SOCKET);
ACTION_OUTPUT_SOCKET.combineWith(CHECK_INPUT_SOCKET);
ACTION_OUTPUT_SOCKET.combineWith(TIMER_INPUT_SOCKET);
ACTION_OUTPUT_SOCKET.combineWith(EFFECTCHAIN_INPUT_SOCKET);

TIMER_OUTPUT_SOCKET.combineWith(EFFECT_INPUT_SOCKET);
TIMER_OUTPUT_SOCKET.combineWith(CHECK_INPUT_SOCKET);
TIMER_OUTPUT_SOCKET.combineWith(EFFECTCHAIN_INPUT_SOCKET);

EFFECT_OUTPUT_SOCKET.combineWith(EFFECT_INPUT_SOCKET);
EFFECT_OUTPUT_SOCKET.combineWith(CHECK_INPUT_SOCKET);
EFFECT_OUTPUT_SOCKET.combineWith(TIMER_INPUT_SOCKET);
EFFECT_OUTPUT_SOCKET.combineWith(EFFECTCHAIN_INPUT_SOCKET);

CHECK_OUTPUT_SOCKET.combineWith(EFFECT_INPUT_SOCKET);
CHECK_OUTPUT_SOCKET.combineWith(CHECK_INPUT_SOCKET);
CHECK_OUTPUT_SOCKET.combineWith(TIMER_INPUT_SOCKET);
CHECK_OUTPUT_SOCKET.combineWith(EFFECTCHAIN_INPUT_SOCKET);

EFFECTCHAIN_OUTPUT_SOCKET.combineWith(EFFECT_INPUT_SOCKET);
EFFECTCHAIN_OUTPUT_SOCKET.combineWith(CHECK_INPUT_SOCKET);
EFFECTCHAIN_OUTPUT_SOCKET.combineWith(TIMER_INPUT_SOCKET);
EFFECTCHAIN_OUTPUT_SOCKET.combineWith(EFFECTCHAIN_INPUT_SOCKET);
